module.exports = __webpack_public_path__ + "static/media/arrow-big-right.84590c5d.svg";